import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityOidcConfigurationsByCustomerIdByIdGetSlice } from './get';

export const securityOidcConfigurationsByCustomerByIdReducers = combineReducers({
	get: securityOidcConfigurationsByCustomerIdByIdGetSlice.asyncReducers
});

export const securityOidcConfigurationsByCustomerByIdWatchers = combineAllWatchers([
	securityOidcConfigurationsByCustomerIdByIdGetSlice.asyncWatchers
]);
